import React from 'react';
import styled from 'styled-components';
export const HCPCSDiv = styled.div.withConfig({
  displayName: "HCPCSIcon__HCPCSDiv",
  componentId: "m89t9o-0"
})(["background-color:#654321;", " width:20px;height:20px;cursor:pointer;padding:1px;border-radius:10px;display:flex;flex-direction:row;align-items:center;align-content:center;justify-content:center;font-family:'Muli',sans-serif;font-size:1rem;font-weight:600;line-height:1;"], props => `color: ${props.theme.palette.common.white};`);
export const HCPCSIcon = ({
  onClick
}) => /*#__PURE__*/React.createElement(HCPCSDiv, {
  id: "hcpcs",
  onClick: onClick
}, "H");